export function GetUrlArrayFromImageSet(imageSets, type) {
    var _a, _b, _c;
    if (!imageSets || imageSets.length < 1)
        return;
    return ((_c = (_b = (_a = imageSets === null || imageSets === void 0 ? void 0 : imageSets.find((a) => a.type === type)) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.filter((a) => { var _a; return (_a = a === null || a === void 0 ? void 0 : a.mimeType) === null || _a === void 0 ? void 0 : _a.includes('image'); })) === null || _c === void 0 ? void 0 : _c.map((b) => b === null || b === void 0 ? void 0 : b.url));
}
